<div class="journey" data-testid="pre-app-journey">
  @if (journey().review_due_at) {
    <p class="journey__promise" [class.journey__promise--late]="journey().review_overdue">
      <app-icon [name]="journey().review_overdue ? 'alert-triangle' : 'clock'" [size]="16" />
      @if (journey().review_overdue) {
        The client was promised a review within one business day. That fell due
        {{ journey().review_due_at | date: 'medium' }}.
      } @else {
        Review promised to the client by {{ journey().review_due_at | date: 'medium' }}.
      }
    </p>
  }

  @if (showLegend()) {
    <ul class="journey__legend" aria-label="Legend">
      <li data-state="done">Done</li>
      <li data-state="current">Waiting here</li>
      <li data-state="upcoming">Expected next</li>
      <li data-state="branch">Possible branch</li>
    </ul>
  }

  <div class="journey__grid" role="list">
    <div class="journey__head" aria-hidden="true">
      <span></span>
      @for (lane of lanes; track lane.key) {
        <span>{{ lane.label }}</span>
      }
    </div>

    @for (phase of rows(); track phase.key; let i = $index) {
      <section class="journey__phase" role="listitem" [attr.aria-label]="phase.title">
        <h3 class="journey__phase-title">
          <span class="journey__phase-num">{{ i + 1 }}</span
          >{{ phase.title }}
        </h3>
        @for (steps of phase.lanes; track $index; let l = $index) {
          <div class="journey__lane">
            @for (step of steps; track step.key) {
              <article
                class="jstep"
                [attr.data-state]="step.state"
                [attr.data-tone]="step.tone"
                [attr.data-testid]="'journey-step-' + step.key"
                [attr.aria-current]="step.state === 'current' ? 'step' : null"
              >
                <span class="jstep__box" aria-hidden="true">
                  @if (marker[step.state]; as icon) {
                    <app-icon [name]="icon" [size]="12" />
                  }
                </span>
                <div class="jstep__body">
                  <span class="cdk-visually-hidden">{{ stateLabel[step.state] }}:</span>
                  <span class="jstep__lane">{{ lanes[l].label }}</span>
                  <strong class="jstep__title">{{ step.title }}</strong>
                  <span class="jstep__who">{{ step.who }}</span>
                  @if (step.detail) {
                    <span class="jstep__detail">{{ step.detail }}</span>
                  }
                  @if (step.at || step.actor) {
                    <span class="jstep__meta">
                      {{ step.at ? (step.at | date: 'medium') : '' }}
                      {{ step.at && step.actor ? '·' : '' }} {{ step.actor }}
                    </span>
                  }
                  @if (step.rule) {
                    <span class="jstep__rule">{{ step.rule }}</span>
                  }
                  @if (step.emails.length) {
                    <span class="jstep__email">
                      <app-icon name="mail" [size]="14" /> {{ emailLabel(step) }}
                    </span>
                  }
                </div>
              </article>
            }
          </div>
        }
      </section>
    }
  </div>
</div>
